import React from "react"

import HelmetBasics from "../../components/HelmetBasics"

const Partners = () => {
	return (
		<>
			<HelmetBasics title="Partnerzy" />
			<p>PLACEHOLDER</p>
		</>
	)
}

export default Partners
